var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{attrs:{"label":_vm.field.name,"prepend-icon":"attach_file"},on:{"click":_vm.onPickFile},model:{value:(_vm.fileName),callback:function ($$v) {_vm.fileName=$$v},expression:"fileName"}}),_c('input',{ref:"fileInput",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"*/*"},on:{"change":_vm.onFilePicked}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }